import defineApi from '../define-api'
import http from '../application-api'

export const searchFlowAttachments = defineApi((config, params) => {
  config.params = params
  return http.load('/flow_attachment/search', config)
})

